export { useFeatureHomePage } from './use-feature-home-page';
